import style from './Markets.module.css';
import NumberFormatter from "../libs/NumberFormatter";

export default function Markets(
    props: {
        currentTickers: Record<string, {name: string, value: number}>,
        initialTickers: Record<string, {name: string, value: number}>,
        selected: string,
        onTickerSelect: (ticker: {symbol: string, value: number, key: string}) => void
    }
) {

    return (
        <div className={`mx-4 my-1 py-2 border-t border-b border-dotted border-black overflow-scroll ${style.scrollbar}`}>
            <div className="flex">
                {
                    props.currentTickers && Object.entries(props.currentTickers).map(([symbol, ticker]) => {

                        const changeAmount = ticker.value - props.initialTickers[symbol].value;
                        const changePercent = changeAmount / props.initialTickers[symbol].value * 100;

                        return <div
                                key={symbol}
                                className={`h-18 w-48 px-2 py-1 mx-4 text-xs
                                border-l-8 ${changePercent > 0 ? 'border-green-500/50' : 'border-red-500/50'}
                                ${symbol === props.selected ? 'bg-gray-200' : 'hover:bg-gray-200'}`}
                                onClick={() => props.onTickerSelect({symbol: symbol, value: ticker.value, key: symbol})}
                            >
                                <div className={style.tickerSymbol}>{symbol}</div>
                                <div>{NumberFormatter.toCurrency(ticker.value)}</div>
                                <div className="w-48">
                                    <span className="pr-2">{NumberFormatter.toCurrency(changeAmount)}</span>
                                    <span className="pr-2">{NumberFormatter.toNumber(changePercent, 2)}%</span>
                                    <span></span>
                                </div>
                            </div>;
                        }
                    )
                }
            </div>
        </div>
    );

}